"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext } from "react";
import { Toaster as Sonner, type ToasterProps } from "sonner";
import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from "lucide-react";
import { ColorModeContext } from "@contexts/color-mode";

/** Above `Dialog` (`99999`) and in-modal popovers (`100010`). */
const TOAST_Z_INDEX = 100020;
const Toaster = t0 => {
  const $ = _c(8);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  const {
    mode
  } = useContext(ColorModeContext);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      zIndex: TOAST_Z_INDEX,
      pointerEvents: "auto",
      "--normal-bg": "var(--popover)",
      "--normal-text": "var(--popover-foreground)",
      "--normal-border": "var(--border)",
      "--border-radius": "var(--radius)"
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      success: <CircleCheckIcon className="size-4" />,
      info: <InfoIcon className="size-4" />,
      warning: <TriangleAlertIcon className="size-4" />,
      error: <OctagonXIcon className="size-4" />,
      loading: <Loader2Icon className="size-4 animate-spin" />
    };
    t3 = {
      classNames: {
        toast: "cn-toast"
      }
    };
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== mode || $[6] !== props) {
    t4 = <Sonner theme={mode} className="toaster group pointer-events-auto" style={t1 as React.CSSProperties} icons={t2} toastOptions={t3} {...props} />;
    $[5] = mode;
    $[6] = props;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export { Toaster };